import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { User } from 'app/classes/user';
import { AuthService } from 'app/services/auth.service';
import { Observable } from 'rxjs';

@Component({
    // tslint:disable-next-line:component-selector
  selector: 'dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  currentUser$: Observable<User>;

  constructor(private router: Router,
    private auth: AuthService) {}

  ngOnInit(): void {
    this.currentUser$ = this.auth.currentUserObs;
  }

  openReport(path: string) {
    this.router.navigate([`/explore/${path}`]);
  }
}
